import { Card, CardContent, Typography, Box, Chip } from "@mui/material";
import React from "react";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

function CardSummary({ title, value, icon, trend, trendUp }) {
    return (
        <>
            <Card sx={{ 
                height: '100%',
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
                }
            }}>
                <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                        <Box sx={{ 
                            p: 1.5, 
                            borderRadius: 2, 
                            bgcolor: '#FFEAED',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            {icon}
                        </Box>
                        {trend && (
                            <Chip
                                icon={trendUp ? <TrendingUpIcon /> : <TrendingDownIcon />}
                                label={trend}
                                size="small"
                                sx={{
                                    bgcolor: trendUp ? '#E8F5E8' : '#FFEBEE',
                                    color: trendUp ? '#2E7D32' : '#C62828',
                                    fontWeight: 600,
                                    fontSize: '0.75rem'
                                }}
                            />
                        )}
                    </Box>
                    
                    <Typography 
                        variant="h4" 
                        sx={{ 
                            fontWeight: 700, 
                            color: '#1a1a1a',
                            mb: 1,
                            fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' }
                        }}
                    >
                        {value}
                    </Typography>
                    
                    <Typography
                        variant="body2"
                        sx={{
                            color: '#666',
                            fontWeight: 500,
                            fontSize: '0.875rem'
                        }}
                    >
                        {title}
                    </Typography>
                </CardContent>
            </Card>
        </>
    );
}

export { CardSummary };
